<template>
 
  <div class="">
    <!-- ======================== SLIDER SIZE ANDROID ========================  -->
 
    <q-responsive  v-if="$q.screen.lt.sm" :ratio="16/9" style="width: 500px; max-width: 100%;">
      <q-carousel swipeable animated :autoplay="true" arrows v-model="slide" infinite >
        <q-carousel-slide v-for="n in this.list_slide" :key="n.index" :name="n.id" :img-src="$store.state.FILE_LOAD+n.file">
          <div class="absolute-bottom" style="text-align: center; padding: 12px; color: white; background-color: rgba(0, 0, 0, .3)">
          <div class="text-h6 text-weight-bolder" style="font-family:garamond; text-shadow: 2px 2px 4px teal;">Elektronik Riset & Inovasi Daerah</div>
          <br>
          <q-btn href="http://admin-rida.konaweselatankab.go.id" color="teal">
      <div>Izin Penelitian</div>
    </q-btn>
        </div>
        </q-carousel-slide>
      </q-carousel>
    </q-responsive>
    
    <!-- ======================== SLIDER SIZE ANDROID ========================  -->

    <!-- ======================== SLIDER SIZE PC ========================  -->
  
      <q-carousel v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" class="q-mt-xxs" swipeable animated :autoplay="true" arrows v-model="slide" height="555px" infinite >
        <q-carousel-slide v-for="n in this.list_slide" :key="n.index" :name="n.id" :img-src="$store.state.FILE_LOAD+n.file">
          <div class="absolute-bottom" style="text-align: center; padding: 12px; color: white; background-color: rgba(0, 0, 0, .3)">
          <div class="text-h3 text-weight-bolder" style="font-family:garamond; text-shadow: 2px 2px 4px teal;">Elektronik Riset & Inovasi Daerah</div>
          <br>
          <q-btn href="http://admin-rida.konaweselatankab.go.id" color="teal">
      <div>Izin Penelitian</div>
    </q-btn>
        </div>
        </q-carousel-slide>
      </q-carousel>    
 
    <!-- ======================== SLIDER SIZE PC ========================  -->

    <!-- ======================== Sambutan ========================  -->
    <br><br><br>
    <center>
    </center>
    <br>
    <div class="q-my-xxs q-py-lg q-px-xxs text-center bg-white text-black" v-if="$q.screen.lt.sm">
      <div class="text-h6 text-weight-bolder">ALUR USULAN PENELITIAN</div>
    </div>
    <br>
    <div class="q-my-xxs q-py-lg q-px-xxs text-center bg-white text-black" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="text-h4 text-weight-bolder">ALUR USULAN PENELITIAN</div>
    </div>
    <div class="q-pa-xl row q-col-gutter-lg">
      <div class="col-12 col-md-4">
        <div style="box-shadow: 5px 5px 2px teal;">
        
        <q-card flat bordered class="my-card bg-secondary text-center text-white" >

      <q-card-section>
        <div class="text-h1"><span class="material-icons-outlined">
how_to_reg
</span></div>
        <div class="text-h6">Register Akun</div>
        <br>
        <q-separator dark inset />

      <q-card-section>
        Pertama anda harus mendaftarkan akun untuk masuk ke sistem Erida sebagai pengguna.
      </q-card-section>
      </q-card-section>

      

      <!-- <q-card-section>
        
      </q-card-section> -->
    </q-card>
      </div>
      </div>
      <div class="col-12 col-md-4">
        <div style="box-shadow: 5px 5px 2px teal;">
        <q-card flat bordered class="my-card bg-secondary text-center text-white">
      <q-card-section>
        <div class="text-h1"><span class="material-icons-outlined">
description
</span></div>
        <div class="text-h6" text-color>Input Form Usulan Penelitian</div>
        <br>
        <q-separator dark inset />

      <q-card-section>
        Kedua silahkan pilih menu usulan kemudian isi dan upload data yang diperlukan.
      </q-card-section>
      </q-card-section>
    </q-card>
    </div>
      </div>
      <div class="col-12 col-md-4">
        <div style="box-shadow: 5px 5px 2px teal;">
        <q-card flat bordered class="my-card bg-secondary text-center text-white">
      <q-card-section>
        <div class="text-h1"><span class="material-icons-outlined">
fact_check
</span></div>
        <div class="text-h6" text-color>Status Pengusulan</div>
        
<br>
      <q-separator dark inset />

      <q-card-section>
        Ketiga Lihat status pengajuan usulan melalui menu reporting atau email pengusul.
      </q-card-section>
      </q-card-section>
    </q-card>
      </div>
      </div>
      <div class="col-12 col-md-4">
        <div style="box-shadow: 5px 5px 2px teal;">
        <q-card flat bordered class="my-card bg-secondary text-center text-white">
      <q-card-section>
        <div class="text-h1"><span class="material-icons-outlined">
text_snippet
</span></div>
        <div class="text-h6" text-color>Mengisi Survey IKM</div>
        <br>
        <q-separator dark inset />

      <q-card-section>
        Keempat jika status usulan sudah terverifikasi anda akan diminta untuk mengisi survey.
      </q-card-section>
      </q-card-section>
    </q-card>
      </div>
      </div>
      <div class="col-12 col-md-4">
        <div style="box-shadow: 5px 5px 2px teal;">
        <q-card flat bordered class="my-card bg-secondary text-center text-white">
      <q-card-section>
        <div class="text-h1"><span class="material-icons-outlined">
file_download
</span></div>
        <div class="text-h6">Undah Surat Rekomendasi</div>
        <br>
        <q-separator dark inset />

      <q-card-section>
        Kelima yaitu surat rekomendasi hanya bisa diundah setelah pengusul mengisi survey.
      </q-card-section>
      </q-card-section>

    </q-card>
      </div>
      </div>
      <div class="col-12 col-md-4">
        <div style="box-shadow: 5px 5px 2px teal;">
        <q-card flat bordered class="my-card bg-secondary text-center text-white">
      <q-card-section>
        <div class="text-h1"><span class="material-icons-outlined">
file_upload
</span></div>
        <div class="text-h6">Unggah Laporan Akhir</div>
        <br>
        <q-separator dark inset />

      <q-card-section>
        Keenam yaitu laporan akhir perlu diunggah agar penelitian dapat dipublish pada aplikasi Erida.
      </q-card-section>
      </q-card-section>
      
    </q-card>
      </div>
      </div>
    <!-- </div> -->
    </div>
    <br>
    <br>

    <div class="q-pr-xl q-pl-xl q-pt-md q-pb-md row q-col-gutter-lg">
           <div class="col-12 col-md-3 frWidget">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-blue-9 row items-center justify-center">
                  <q-icon name="assessment" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-blue-7">
                  <span class="frWidgetText1">Izin Penelitian</span> <br>
                  <span class="frWidgetText2">{{jumlah_penelitian}}</span>
                </div>
             </div>
           </div>
            <div class="col-12 col-md-3 frWidget ">
              <div class="row shadow-5 frWidgetSub">
                 <div class="col-4 frWidgetSub1 text-center bg-light-green-7  row items-center justify-center">
                   <q-icon name="lightbulb" style="font-size:420%; color:white" />
                 </div>
                 <div class="col-8 frWidgetSub2 bg-light-green-4">
                   <span class="frWidgetText1">Riset</span> <br>
                   <span class="frWidgetText2">{{jumlah_riset}}</span>
                 </div>
              </div>
            </div>
           <div class="col-12 col-md-3 frWidget ">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-orange-7  row items-center justify-center">
                  <q-icon name="language" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-orange-4">
                  <span class="frWidgetText1">Aksi Perubahan</span> <br>
                  <span class="frWidgetText2">{{jumlah_aksi}}</span>
                </div>
             </div>
           </div>
           <div class="col-12 col-md-3 frWidget">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-deep-orange-7  row items-center justify-center">
                  <q-icon name="info" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-deep-orange-4">
                  <span class="frWidgetText1">Kreasi & Inovasi</span> <br>
                  <span class="frWidgetText2">{{jumlah_krenova}}</span>
                </div>
             </div>
           </div>
         </div>

         <div class="q-pr-xl q-pl-xl q-pt-md q-pb-xl row q-col-gutter-lg">
           <div class="col-12 col-md-3 frWidget">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-lime-9 row items-center justify-center">
                  <q-icon name="devices" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-lime-7">
                  <span class="frWidgetText1">Tema Penelitian</span> <br>
                  <span class="frWidgetText2">{{jumlah_tema}}</span>
                </div>
             </div>
           </div>
           <div class="col-12 col-md-3 frWidget ">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-cyan-9  row items-center justify-center">
                  <q-icon class="vertical-middle" name="device_hub" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-cyan-7">
                  <span class="frWidgetText1">T T G</span> <br>
                  <span class="frWidgetText2">{{jumlah_teknologi}}</span>
                </div>
             </div>
           </div>
           <div class="col-12 col-md-3 frWidget ">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-teal-7  row items-center justify-center">
                  <q-icon name="image" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-teal-4">
                  <span class="frWidgetText1">Foto Kegiatan</span> <br>
                  <span class="frWidgetText2">{{jumlah_foto}}</span>
                </div>
             </div>
           </div>
           <div class="col-12 col-md-3 frWidget">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-light-blue-7  row items-center justify-center">
                  <q-icon name="videocam" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-light-blue-4">
                  <span class="frWidgetText1">Video Kegiatan</span> <br>
                  <span class="frWidgetText2">{{jumlah_video}}</span>
                </div>
             </div>
           </div>
         </div>

    <div class="q-pa-xxs q-gutter-lg">
    <div class="row justify-between">


    <q-parallax v-if="$q.screen.lt.sm" 
      src="img/bg.jpg" :height="500" :speed="1"
    >
    <div class="q-pa-xl row q-col-gutter-lg">
      <div class="col-12 col-md-1">
    </div>
      <div class="col-12 col-md-7">
        <br>
        <div class="text-h6 text-weight-bolder text-white" style="font-family:garamond; text-shadow: 2px 2px 4px teal;">KREATIFITAS & INOVASI DAERAH</div>
        <br>
        <br>
        <span class="text-justify" style="font-size: 14px; line-height: 2; color: white;">
              Kretifitas & Inovasi Daerah yang diselenggarakan Badan Riset dan
              Inovasi Daerah Kabupaten Konawe Selatan, INOTEK adalah bentuk
              apresiasi Bupati Konawe Selatan kepada para inovator yang
              memajukan daerah produk inovasi dan teknologi untuk masyarakat luas.
            </span>
            <br>
            <br>
            <br>
            <q-btn to="/inotek" color="teal">
      <div>LIHAT SELENGKAPNYA</div>
    </q-btn>
      </div>
    </div>
    </q-parallax>

    <q-parallax v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" class="q-mt-xxs" 
      src="img/bg.jpg" :height="500" :speed="1"
    >
    <div class="q-pa-xl row q-col-gutter-lg">
      <div class="col-12 col-md-1">
    </div>
      <div class="col-12 col-md-7">
        <br>
        <div class="text-h4 text-weight-bolder text-white" style="font-family:garamond; text-shadow: 2px 2px 4px teal;">KREATIFITAS & INOVASI DAERAH</div>
        <br>
        <br>
        <span class="" style="font-size: 17px; line-height: 2; color: white;">
              Kretifitas & Inovasi Daerah yang diselenggarakan Badan Riset dan
              Inovasi Daerah Kabupaten Konawe Selatan, INOTEK adalah bentuk
              apresiasi Bupati Konawe Selatan kepada para inovator yang
              memajukan daerah produk inovasi dan teknologi untuk masyarakat luas.
            </span>
            <br>
            <br>
            <br>
            <q-btn to="/krenova" color="teal">
      <div>LIHAT SELENGKAPNYA</div>
    </q-btn>
      </div>
      <div  class="col-12 col-md-4">
        <img src="img/inotek.png" style="width: 300px">
      </div>
    </div>
    </q-parallax>


    </div>
  </div>

    <!-- ======================== BERITA ========================  -->
    <br>
    <br>
    <div class="q-my-md q-py-lg q-px-md text-center bg-secondary-6 text-black" v-if="$q.screen.lt.sm">
      <div class="text-h6 text-weight-bolder">BERITA RISET & INOVASI DAERAH</div>
    </div>
    <div class="q-my-md q-py-lg q-px-md text-center bg-secondary-6 text-black" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="text-h6 text-weight-bolder">BERITA RISET & INOVASI DAERAH</div>
    </div>
    
    
    <div class="q-pa-xl row items-start q-col-gutter-xl">
<div class="col-12 col-md-4" v-for="data in list_berita" :key="data.id">
      <q-card class="my-card" >
      <q-img :src="$store.state.FILE_PATH+data.foto" height="350px">
      <div class="absolute-bottom">
        <div class="text-h6 text-justify">{{data.judul}}</div>
        
      </div>
      </q-img>

      <q-card-section>
        <q-item>
          <q-item-section avatar>
            <q-icon color="secondary" name="assignment" />
          </q-item-section>

          <q-item-section>
            <q-item-label>{{data.createBy}}</q-item-label>
            <q-item-label caption>{{convert_tgl(data.createAt)}}</q-item-label>
          </q-item-section>
        </q-item>
        <!-- <div class="text-h6">{{data.judul}}</div>
        <div class="text-subtitle2">{{data.createBy}}</div> -->
        <!-- <div v-html="data.deskripsi" class="text-justify"></div> -->
      </q-card-section>

      <q-card-actions>
        <q-btn flat  @click="push_berita(data.id)" style="color: #26A69A" label="Baca Selengkapnya" />
      </q-card-actions>
    </q-card>
</div>
    </div>

    <!-- ======================== BERITA ========================  -->
    <br>
    <br>
    <div class="bg-teal-1">
    <div class="q-my-md q-py-lg q-px-md text-center bg-secondary-6 text-black" v-if="$q.screen.lt.sm">
      <div class="text-h6 text-weight-bolder">TIM BRIDA</div>
    </div>
    <div class="q-my-md q-py-lg q-px-md text-center bg-secondary-6 text-black" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="text-h6 text-weight-bolder">TIM BRIDA</div>
    </div>
    </div>
    <div class="q-pa-xl row items-start q-col-gutter-xl bg-teal-1">
<div class="col-12 col-md-4" v-for="data in list_tim" :key="data.id">
      <q-card class="my-card" >
      <q-img :src="$store.state.FILE_PATH+data.foto" height="350px">
      <div class="absolute-bottom">
        <div class="text-h6 text-center"  @click="mdl_open = true, selectData(data)">{{data.judul}}</div>
        
      </div>
      </q-img>
    </q-card>
</div>
    </div>

           <!-- ================================================= MODAL OPEN ================================================ -->
               <q-dialog v-model="mdl_open">
                 <q-card style="width: 700px; max-width: 80vw;">
        <q-img :src="$store.state.FILE_PATH+tim.fotoOld" width="100%" />

        <q-card-section>
          <div class="row no-wrap items-center">
            <div class="col text-h6 ellipsis">
              {{tim.judul}}
            </div>
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="text-subtitle1" v-html="tim.deskripsi">
          </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn v-close-popup flat color="primary" label="Tutup" />
        </q-card-actions>
      </q-card>
              </q-dialog>
            <!-- ================================================= MODAL OPEN ================================================ -->

  </div>     
</template>

<script>
export default {
  name: 'Beranda',
  data() {
    return {
      list_slide:[],
      // jumlah_penelitian : '',
      // jumlah_pengabdian : '',
      // jumlah_sida : '',
      // jumlah_artikel : '',
      list_berita:[],
      list_tim:[],
      form : {
                id : '',
                judul : '',
                sumber : '',
                deskripsi : '',
                isi : '',
                foto : '',
                createBy : '',
                createAt : '',
            },

            tim : {
                id : '',
                judul : '',
                deskripsi : '',
                foto : '',
                fotoOld : '',
                createBy : '',
                createAt : '',
            },

      slide: 1,
      mdl_open : false,

    }
  },
  methods: {
    slides: function() {
        this.cek_load_data = true;
      fetch(this.$store.state.URL_SLIDE, {
        method: "GET",
 
 
      })
        .then(res => res.json())
        .then(res_data => {
            this.list_slide = res_data;  
        });
    },
    getBerita: function() {
                this.cek_load_data = true;
                fetch(this.$store.state.URL_BERITA + "viewPage", {
                    method: "POST",
                    headers: {
                    "content-type": "application/json",
                    },
                        body: JSON.stringify({
                        data_ke: 1
                    })
                })
                    .then(res => res.json())
                    .then(res_data => {
                        this.list_berita = res_data.data;
                        this.page_last = res_data.jml_data;
                        this.cek_load_data = false;
                        console.log(res_data);
                });
            },
            push_berita : function(id){
                this.$router.push('/berita_brida/'+id);
            },
            getTim: function() {
                this.cek_load_data = true;
                fetch(this.$store.state.URL_BERANDA + "tim", {
                    method: "GET",
                    headers: {
                    "content-type": "application/json",
                    },
                    //     body: JSON.stringify({
                    //     data_ke: 1
                    // })
                })
                    .then(res => res.json())
                    .then(res_data => {
                        this.list_tim = res_data;
                        // this.page_last = res_data.jml_data;
                        this.cek_load_data = false;
                        console.log(res_data);
                });
            },
    // getJumlahPenelitian : function(){
    //     fetch(this.$store.state.URL_BERANDA + "penelitian", {
    //         method: "POST",
    //         // headers: {
    //         //   "content-type": "application/json",
    //         //   authorization: "kikensbatara " + localStorage.token
    //         // },
    //     })
    //         .then(res => res.json())
    //         .then(res_data => {
    //           // console.log(res_data);
    //           this.jumlah_penelitian = res_data.data[0].jumlah_penelitian;
    //           // console.log(jumlah_pelaku);
    //     });
    //   },

    //   getJumlahSida : function(){
    //     fetch(this.$store.state.URL_BERANDA + "sida", {
    //         method: "POST",
    //         // headers: {
    //         //   "content-type": "application/json",
    //         //   authorization: "kikensbatara " + localStorage.token
    //         // },
    //     })
    //         .then(res => res.json())
    //         .then(res_data => {
    //           // console.log(res_data);
    //           this.jumlah_sida = res_data.data[0].jumlah_sida;
    //           // console.log(jumlah_pelaku);
    //     });
    //   },

    //   getJumlahArtikel : function(){
    //     fetch(this.$store.state.URL_BERANDA + "artikel", {
    //         method: "POST",
    //         // headers: {
    //         //   "content-type": "application/json",
    //         //   authorization: "kikensbatara " + localStorage.token
    //         // },
    //     })
    //         .then(res => res.json())
    //         .then(res_data => {
    //           // console.log(res_data);
    //           this.jumlah_artikel = res_data.data[0].jumlah_artikel;
    //           // console.log(jumlah_pelaku);
    //     });
    //   },

    //   getJumlahPengabdian : function(){
    //     fetch(this.$store.state.URL_BERANDA + "pengabdian", {
    //         method: "POST",
    //         // headers: {
    //         //   "content-type": "application/json",
    //         //   authorization: "kikensbatara " + localStorage.token
    //         // },
    //     })
    //         .then(res => res.json())
    //         .then(res_data => {
    //           // console.log(res_data);
    //           this.jumlah_pengabdian = res_data.data[0].jumlah_pengabdian;
    //           // console.log(jumlah_pelaku);
    //     });
    //   },

    getJumlahPenelitian : function(){
        fetch(this.$store.state.URL_BERANDA + "penelitian", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_penelitian = res_data.data[0].jumlah_penelitian;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahKrenova : function(){
        fetch(this.$store.state.URL_BERANDA + "krenova", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_krenova = res_data.data[0].jumlah_krenova;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahArtikel : function(){
        fetch(this.$store.state.URL_BERANDA + "artikel", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_artikel = res_data.data[0].jumlah_artikel;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahAksi : function(){
        fetch(this.$store.state.URL_BERANDA + "aksi", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_aksi = res_data.data[0].jumlah_aksi;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahTema : function(){
        fetch(this.$store.state.URL_BERANDA + "tema", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_tema = res_data.data[0].jumlah_tema;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahTeknologi : function(){
        fetch(this.$store.state.URL_BERANDA + "teknologi", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_teknologi = res_data.data[0].jumlah_teknologi;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahRiset : function(){
        fetch(this.$store.state.URL_BERANDA + "riset", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_riset = res_data.data[0].jumlah_riset;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahVideo : function(){
        fetch(this.$store.state.URL_BERANDA + "video", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_video = res_data.data[0].jumlah_video;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahFoto : function(){
        fetch(this.$store.state.URL_BERANDA + "foto", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_foto = res_data.data[0].jumlah_foto;
              // console.log(jumlah_pelaku);
        });
      },

      selectData : function(data){
        console.log(data.foto);
        this.tim.id = data.id
        this.tim.judul = data.judul
        this.tim.deskripsi = data.deskripsi
        this.tim.foto = this.tim.foto
        this.tim.fotoOld = data.foto
        console.log(this.tim.fotoOld);
    },

      convert_tgl: function(dateString) {
                    var date = new Date(dateString);
                    var getBulan = date.getMonth() + 1; var bulan = '';
                    if (getBulan == '1') {bulan = 'Januari'} 
                    else if(getBulan == '2') {bulan = 'Februari'}
                    else if(getBulan == '3') {bulan = 'Maret'}
                    else if(getBulan == '4') {bulan = 'April'}
                    else if(getBulan == '5') {bulan = 'Mei'}
                    else if(getBulan == '6') {bulan = 'Juni'}
                    else if(getBulan == '7') {bulan = 'Juli'}
                    else if(getBulan == '8') {bulan = 'Agustus'}
                    else if(getBulan == '9') {bulan = 'September'}
                    else if(getBulan == '10') {bulan = 'Oktober'}
                    else if(getBulan == '11') {bulan = 'November'}
                    else if(getBulan == '12') {bulan = 'Desember'}



                    return date.getDate() + " " + bulan + " " + date.getFullYear();
                    // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                }
  },
  mounted() {
    this.getBerita()
    this.getTim()
    this.slides()
    this.getJumlahPenelitian();
    this.getJumlahRiset();
    this.getJumlahKrenova();
    this.getJumlahAksi();
    this.getJumlahTema();
    this.getJumlahTeknologi();
    this.getJumlahFoto();
    this.getJumlahVideo();
    // this.getJumlahPenelitian()
    // this.getJumlahPengabdian()
    // this.getJumlahSida()
    // this.getJumlahArtikel()
  },
}
</script>
